/** Bounded, deterministic decorative motion; never changes gameplay or hit boxes. */
export function streamDrop(time: number, index: number, duration = 1650) {
  const phase = ((time / duration + index * .137) % 1 + 1) % 1;
  return { progress: phase * phase, opacity: Math.sin(phase * Math.PI) * .64 };
}

export function harbourDrift(time: number) {
  const phase = time * Math.PI * 2 / 42000;
  return { x: .14 + .055 * Math.sin(phase), y: Math.sin(phase + .7) * 3, angle: Math.sin(phase * 3) * .7 };
}
